// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationByExternalIdAsyncRequestModel from '../../model/get-organisation-by-external-id-async-request-model';
import GetOrganisationByExternalIdAsyncRequestDTO from '../dto/get-organisation-by-external-id-async-request-dto';
import dtoSchema from '../schemas/get-organisation-by-external-id-async-request-schema';

export default abstract class GetOrganisationByExternalIdAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationByExternalIdAsyncRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
    }
  }
  /**
  */
  externalId?: string;

  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAsyncRequestDTO>): GetOrganisationByExternalIdAsyncRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAsyncRequestDTO> | undefined | null): GetOrganisationByExternalIdAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAsyncRequestDTO> | undefined | null): GetOrganisationByExternalIdAsyncRequestModel | undefined {
    return dto ? new GetOrganisationByExternalIdAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationByExternalIdAsyncRequestModel> | GetOrganisationByExternalIdAsyncRequestModel): GetOrganisationByExternalIdAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
    } as GetOrganisationByExternalIdAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationByExternalIdAsyncRequestModel, can not map to GetOrganisationByExternalIdAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
